import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const GymContext = createContext(null);

const STORAGE_KEY = 'selected_gym_id';

export function GymProvider({ children }) {
    const { user } = useAuth();
    const gyms = user?.roles?.includes('owner') ? (user.gyms || []) : [];

    const [selectedGym, setSelectedGymState] = useState(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored && gyms.length > 0) {
            const found = gyms.find(g => String(g.id) === stored);
            if (found) return found;
        }
        if (gyms.length > 0) return gyms[0];
        return null;
    });

    useEffect(() => {
        if (gyms.length > 0) {
            const stored = localStorage.getItem(STORAGE_KEY);
            const found = gyms.find(g => String(g.id) === stored);
            if (found) {
                setSelectedGymState(found);
            } else {
                setSelectedGymState(gyms[0]);
                localStorage.setItem(STORAGE_KEY, String(gyms[0].id));
            }
        }
    }, [gyms]);

    const setSelectedGym = (gym) => {
        setSelectedGymState(gym);
        if (gym) {
            localStorage.setItem(STORAGE_KEY, String(gym.id));
        }
    };

    const value = useMemo(() => ({ selectedGym, setSelectedGym, gyms }), [selectedGym, gyms]);

    return (
        <GymContext.Provider value={value}>
            {children}
        </GymContext.Provider>
    );
}

export function useGym() {
    const context = useContext(GymContext);
    if (!context) {
        throw new Error('useGym must be used within a GymProvider');
    }
    return context;
}
